module.exports = __webpack_public_path__ + "static/media/pinkCross.2c9e12eb.png";